import { Link, useNavigate } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { flaglogin } from '../slices/userSlice'
import { client } from '../api/client'

import "./LoginPage.css"

function LoginPage() {
  const [classroom,setClassroom] = useState(null)
  useEffect(()=>{client.get('/api/classroom').then(r=>setClassroom(r.data)).catch(e=>alert(e))},[])
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [, setClickTimes] = useState(0)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  return (
    <div className='loginMain'>
      <div className='loginLeft'>
        <img className='loginLeftImage' 
        alt=""
        src="https://images.unsplash.com/photo-1664844819758-76e686faf12e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8MTZ8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=900&q=60" />
      </div>
      <div className='loginRight'>
        <p>{classroom?.name}</p>
        {classroom&&classroom.status!=='active'&&<p role="status">{classroom.status==='paused'?'本班课堂已暂停，请等待教师重新激活。':'本班课堂尚未开放或已经关闭。'}</p>}
        <h1  onClick={()=>{setClickTimes(times=>{
            if (times<5) {
              return times+1
            }else{
              navigate('/flag-rank')
            }
          })}}>Welcome Back</h1>
        <div>
          <input  placeholder='type your user name' className='loginInput' value={username} onChange={(e)=>{
            setUsername(e.target.value)
          }} />
        </div>
        <div>
        <input  placeholder='type your password' className='loginInput' type="password" value={password} onChange={(e)=>{setPassword(e.target.value)}} />
        </div>
        <button className='loginBtn' disabled={classroom?.status!=='active'} onClick={async () => {
          try {
          const loginresponse = await dispatch(flaglogin({username,password})).unwrap()
          if (loginresponse.status === 1) {
            const flagInLocal = loginresponse.user.clues.localstorage
            window.localStorage.setItem("user",JSON.stringify({...loginresponse.user,flag:flagInLocal}))
            navigate('/')
          }else{
            alert(loginresponse.message)
            window.localStorage.setItem("login state",'username or password error')
          }
          } catch(e) { alert(String(e)) }
        }}>LOG IN</button>
        
        <div className='signup-and-forgetpassword'>
          <Link to="/score-board" onClick={()=>{
            // alert("暂不开放注册。")
            window.localStorage.setItem("sign up",'sign up clicked, not opening for now.')
          }}>SIGN UP</Link>|<Link to="/forgot-password">🚩FORGET PASSWORD</Link>
        </div>
      </div>
      
    </div>
  )
}

export default LoginPage
